<template>
	<div class="page-main">
		<nav-bar fixed :placeholder="true" title="星礼包" :left-arrow="true" @click-left="back" ></nav-bar>
		
		<div v-for="(item,index) in dataList" :key="index">
			

			<div v-if="item['type'] == 'srkit'">
				<div class="card-title">
					{{item.widget['title']}}
					<p>{{item.widget['description']}}</p>
				</div>
				{{item.widget.shelfBackgroundColourZhForApp}}
				<div class="card-wrap" v-for="(widgetItem,index) in item.widget.item" :key="index"  :style="{background:widgetItem.shelfBackgroundColourZhForApp}">
					<img :src="widgetItem.shelfTitleImageUrl"/>

					<div class="card-item" v-for="(contentItem,index) in widgetItem.content" :key="index">

						<img class="card-item-img" :src="contentItem.imageUrl"/>
						<div class="card-item-text" >
							<div class="title">{{contentItem.title}}</div>
							<div class="description">{{contentItem.description}}</div>
						</div>
						<div class="card-item-btn"  @click="Pay_Card(contentItem)" :style="{background:contentItem.buttonColor}">
							{{contentItem.buttonTitle}}
						</div>
				
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {NavBar} from "vant";
	import {
		GiftList,
		PayCard
	} from "@/api";
	export default {
		data() {
			return {
				qrcode: null,
				time: null,
				info: {},
				dataList:[]
			}
		},
		created() {
			this.init();
		},
		methods: {
			back(){
				this.$router.back();
			},
			async init(){
				let {data} = await GiftList();
				console.log(data)
				this.dataList = data;
			},
			Pay_Card(item) {
				this.info = {
					"consumeNum": 1,
					"name": item.title,
					"price": Number(item.buttonTitle.replace("￥",""))*100,
					"sku": item.sku
				}

				PayCard(this.info).then(d => {
					console.log(d.data.biz_content);
					this.$router.replace({
						name: 'pay',
						query: {
							data: JSON.stringify(d.data)
						}
					})
				})
			},
			pageBack() {
				window.history.back();
			}
		},
		components:{
			NavBar
		},
		beforeDestroy() {
			if (this.time) {
				clearInterval(this.time);
			}
		}
	}
</script>

<style lang="scss" scoped>

img{
	width:100%;
}

.card-title{
	font-size:26px;
	font-weight: bold;
	margin:20px 30px;

	p{
		font-size:24px;
		font-weight: initial;
		margin:0;
	}
}

.card-wrap{
	overflow:hidden;
	border-radius:16px;
	margin:30px;

	&>img{
		display:block;
	}

	.card-item{
		display:flex;
		align-items: center;
		margin:30px 30px;

		&-img{
			width:100px;
			margin-right:20px;
		}

		&-text{
			flex:1;
			min-width:1px;
			font-size:24px;

			.title{
				margin-bottom:6px;
			}

			.description{
				font-size:20px;
				color:#005a3d;
			}
		}

		&-btn{
			width:110px;
			height:50px;
			line-height:50px;
			border-radius:50px;
			color:#fff;
			text-align:center;
		}
	}
}
	
</style>
